import React, { useState } from 'react';
import { useNavigate,useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { api } from '../../app/Api/ApiSlice';

const OrgSuggest= () => {
    const navigate = useNavigate();

    const [text, setText] = useState("");
    const [files, setFiles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const {organization} = useParams()

    // Add files to state
    const addFiles = (e) => {
        const selectedFiles = e.target.files;
        // Limit file input to 12 files
        if (files.length + selectedFiles.length <= 4) {
            setFiles((prev) => [...prev, ...selectedFiles]);
        } else {
            toast.error("You can only upload up to 4 images.");
        }
    };

    // Remove image by index
    const handleRemove = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    // Handle form submission
    const uploadToS3 = async (file) => {
           const presignRes = await api.post("/uploads/presign", {
               filename: file.name,
               contentType: file.type,
           })
   
           const { uploadUrl, key } = presignRes.data
   
           const res = await fetch(uploadUrl, {
               method: "PUT",
               headers: {
                   "Content-Type": file.type,
               },
               body: file,
           })
   
           if (!res.ok) {
               throw new Error(`Upload failed: ${file.name}`)
           }
   
           const baseType = file.type.split("/")[0]
   
           return {
               key,
               type:
                   baseType === "image"
                       ? "image"
                       : baseType === "video"
                           ? "video"
                           : "document",
               mimeType: file.type,
               name: file.name,
               size: file.size,
           }
       }
   
       const handleSubmit = async (e) => {
           e.preventDefault()
   
           if (!text && files.length === 0) {
               toast.error("suggestion cannot be empty")
               return
           }
   
           try {
               setIsLoading(true)
   
               const uploadedFiles = await Promise.all(
                   files.map((file) => uploadToS3(file))
               )
   
               await api.post(`/${organization}/suggestions`, {
                   text,
                   files: uploadedFiles,
               })
   
               toast.success("Suggestion message sent")
               navigate(-1)
           } catch (err) {
               console.error(err)
               toast.error(err.message || "Error,suggestion message not sent")
           } finally {
               setIsLoading(false)
           }
       }
   

    return (
        <div className=''>
            <div className="page-content">
                <div className="">
                    <div className="form-wrapper create-form">
                        <h3 className='form-title'>suggestion box</h3>
                        <form onSubmit={handleSubmit}>
                            <input
                                type='text'
                                placeholder='your identity will be hidden'
                                className='post-text'
                                value={text}
                                onChange={(e) => setText(e.target.value)}
                            />
                            <label htmlFor='images' className='images-header'>Images</label>
                            <div className="images-preview">
                                {
                                    files.map((image, i) => (
                                        <div key={i} className='form-image'>
                                            <img
                                                src={URL.createObjectURL(image)}
                                                alt=''
                                                className='image-preview'
                                            />
                                            <div className="remove-img">
                                                <button type='button' onClick={() => handleRemove(i)}>Remove</button>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                            <input
                                type="file"
                                className='image-input'
                                name='images'
                                multiple
                                accept="image/*"
                                onChange={addFiles}
                            />

                            <div className="post-form-btn">
                                <button type='submit' disabled={isLoading}>
                                    {isLoading ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrgSuggest;
